import AbstractLayerManager from './AbstractLayerManager';
import Request from '../../Request';

/* Fiddle:  http://jsfiddle.net/L3kvnafb/ */

export default class OutlookLayerManager extends AbstractLayerManager {
	constructor(myKey, instance) {
		super(myKey, instance);
		this.name = "Convective Outlook";
		this.popupName = "Convective Outlook";
		this.options.hasPanRefresh = false;
		this.options.hasAutoRefresh = true;

		this.dataOptions = {};
		this.dataOptions.productId = 'SWO';
		this.dataOptions.productLocId = 'DY1';

		this.storage = {};
		this.storage.text = null;
	}
	
	refreshLayer() {
		this.requestData();
	}
	
	requestData() {
		this.inst.setLoadingMonitor(this.id, true);

		if(this.tasks.fetchData === undefined) this.tasks.fetchData = new Request({
			url: 'https://dev.weatherusa.net/api/v1/feed/specprod',
			data: {product_id: 'SWO'},
			link: 'cancel',
			timeout: 30000,
			onSuccess: this.handleResp.bind(this),
			onError: this.handleError.bind(this)
		});

		this.tasks.fetchData.get({product_id: this.dataOptions.productId, product_loc_id: this.dataOptions.productLocId});
	}

	handleError(err) {
		console.error(err);
		this.inst.setLoadingMonitor(this.id, false);
	}
	
	handleResp(resp) {
		if(!this.layer) {
			console.error('Could not find layer for layer ID: ' + this.id);
			return false;
		}
		
		let data = resp.body.data;
		if(data === undefined) throw "SWO product empty";

		// Remove all paths from LayerGroup
		this.layer.clearLayers();
		this.storage.text = data.text;

		L.geoJson(data.geojson, {
			onEachFeature: this.handleFeature.bind(this),
			style: function (feature) {
				return {
				color: feature.properties.color,
				opacity: 1.0,
				fillOpacity: 0.21,
				weight: 2
				};
			}
		}).addTo(this.layer);

		this.inst.setLoadingMonitor(this.id, false);
	}

	handleFeature(feature, layer) {
		layer.on('click', this.handleClick, this);
	}

	handleClick(e) {
		this.inst.forwardedClickHandler(this.id, e, '<div class="alerts-text-view">' + this.storage.text + '</div>');
	}

	getLayerPopupContent(layer) {
		var eventSPC = sprintf('%04u', layer.eventId);
		return '<div class="alerts-text-view"><a target="_blank" href="https://www.spc.noaa.gov/products/md/md' + eventSPC + '.html"><img class="img-responsive" src="https://www.spc.noaa.gov/products/md/mcd' + eventSPC + '.gif" /></a><br /><br />' + e.target.details + '</div>';
	}
}
